<template>
  <section>
    <form @submit.prevent="submitForm" class="m-form m-form--state">
      <div class="modal-body">
        <div class="m-portlet__body">
          <label for="camera_name"><b>{{camera_name}} - {{control_point}}</b></label>
          <div v-if="camera_status == 'on'" style="text-align:center; border-style:double; background-color:black">
            <img :src="picture" width="400">
          </div>
          <div v-else>
            <div v-if="camera_status == 'off'" style="text-align:center; line-height:150px; border-style:double; background-color:black; color:white; height: 150px">
              {{'camera_connection_error' | translate | capitalize }}
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary-orange" @click="testCam">
          {{'test' | translate | capitalize }}
        </button>
        <button type="button" class="btn btn-secondary" :data-dismiss="'modal'" id="btn-cancel-approve" @click="close">
          {{'close' | translate | capitalize }}
        </button>
      </div>
    </form>
  </section>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
export default {
  props: {
    data_send: Object
  },
  data () {
    return {
      camera_id: '',
      camera_status: '',
      camera_name: '',
      control_point: '',
      picture: ''
    }
  },
  computed: {
    ...mapGetters({ modal: 'getStatusTestCameraModal', permissions: 'getUserPermissions' })
  },
  methods: {
    ...mapActions(['setStatusTestCameraModal', 'testCamera']),
    ...mapMutations(['updateStatusTestCameraModal']),
    testCam () {
      this.$spinner.show()
      this.testCamera(this.camera_id)
        .then((res) => {
          if (res.status === 200) {
            this.picture = 'data:image/png;base64,' + res.data
            this.$toast('on_camera_message')
            this.camera_status = 'on'
            this.$spinner.remove()
          }
        })
        .catch((err) => {
          this.$toast('off_camera_error', 4)
          this.$spinner.remove()
          this.camera_status = 'off'
          console.log(err)
        })
    },
    reset () {
      this.picture = ''
      this.camera_status = ''
    },
    close () {
      this.reset()
      this.setStatusTestCameraModal(false)
    }
  },
  created () {
  },
  watch: {
    modal (newVal, oldVal) {
      if (oldVal === false && newVal === true) {
        this.$nextTick(() => {
          if (this.data_send.id) {
            this.camera_id = this.data_send.id
            this.camera_name = this.data_send.name
            this.control_point = this.data_send.control_point_name
            this.testCam()
          }
        })
      }
    }
  }
}
</script>

<style scope>
.center-custom{
  text-align: center !important;
  margin: 0 !important;
}

</style>


// WEBPACK FOOTER //
// TestCamera.vue